import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getOnboardingGuest } from '@/helpers/onboardingGuest';
import { SUCCESS_NAMESPACE } from '@/i18n';

const INVITE_PATH = '/invite';

/**
 * Comprovante do titular com acompanhante pendente: sem este atalho o
 * comprovante era um beco — a pessoa via "tudo certo" e não tinha como voltar
 * para resolver a biometria de quem ainda falta. O botão leva à tela do grupo
 * (`/invite`), que abre direto no cadastro dos acompanhantes.
 *
 * Não aparece para dependente (`role: 'companion'`, entrou pelo link do
 * titular): ele não cadastra ninguém.
 */
export function SuccessCompanionsCta(): JSX.Element | null {
  const { t } = useTranslation(SUCCESS_NAMESPACE);
  const navigate = useNavigate();
  const guest = getOnboardingGuest();

  if (guest === null || guest.role === 'companion' || guest.companions.pending <= 0) {
    return null;
  }

  return (
    <Box sx={{ px: 3, pb: 2 }} data-testid="success-companions-cta">
      <Alert severity="warning" sx={{ mb: 2 }}>
        <AlertTitle>{t('companionsTitle')}</AlertTitle>
        {t('companionsPending', {
          pending: guest.companions.pending,
          declared: guest.companions.declared,
        })}
      </Alert>
      <Button
        variant="contained"
        size="large"
        fullWidth
        onClick={() => navigate(INVITE_PATH)}
        data-testid="success-companions-button"
      >
        {t('companionsCta')}
      </Button>
    </Box>
  );
}
